module.exports = __webpack_public_path__ + "img/inge_whatsapp.e6f533e7.svg";